import type { ComponentProps } from "react";
import * as ResizablePrimitive from "react-resizable-panels";

import { GraphIcon } from "@icons";
import classNames from "classnames";
import styles from "./ResizablePanels.module.scss";

const ResizablePanelGroup = ({
    className,
    ...props
}: ComponentProps<typeof ResizablePrimitive.Group>) => (
    <ResizablePrimitive.Group
        data-slot="resizable-panel-group"
        className={classNames(styles.panelGroup, className)}
        {...props}
    />
);

const ResizablePanel = (
    props: ComponentProps<typeof ResizablePrimitive.Panel>,
) => <ResizablePrimitive.Panel data-slot="resizable-panel" {...props} />;

const ResizableHandle = ({
    withHandle,
    className,
    ...props
}: ComponentProps<typeof ResizablePrimitive.Separator> & {
    withHandle?: boolean;
}) => (
    <ResizablePrimitive.Separator
        data-slot="resizable-handle"
        className={classNames(styles.handle, className)}
        {...props}
    >
        {withHandle && (
            <div className={styles.handleInner}>
                <GraphIcon className={styles.handleIcon} />
            </div>
        )}
    </ResizablePrimitive.Separator>
);

export { ResizablePanelGroup, ResizablePanel, ResizableHandle };
